import { JsonObject, JsonProperty } from 'json2typescript';

//** Odjezd ze zastávky * /
@JsonObject("Departure")
export class Departure {
  @JsonProperty('id', String)
  id: string = "";
  @JsonProperty('vehicleType', String)
  vehicleType: string = ""
  @JsonProperty('name', String, true)
  name: string | undefined = undefined;
  @JsonProperty('lineNumber', Number, true)
  lineNumber: number | undefined = undefined;
  @JsonProperty('serviceNumber', Number, true)
  serviceNumber: number | undefined = undefined;
  @JsonProperty('extLineName', String, true)
  extLineName: string | undefined = undefined;
  @JsonProperty('sourceType', String)
  sourceType: string = "";  // S - autobus/tramvaj/trolejbus (MHD, VLD), K - vlak
  @JsonProperty('lineType', String, true)
  lineType: string | undefined = undefined;
  @JsonProperty('destStation', String)
  destStation: string = "";
  @JsonProperty('depTime', String)
  depTime: string = "";
  @JsonProperty('delay', Number, true)
  delay: number | undefined = undefined;
  @JsonProperty('isDetour', Boolean, true)
  "isDetour": boolean | undefined = undefined;
  @JsonProperty('platform', String, true)
  "platform": string | undefined = undefined;
  @JsonProperty('crId', Number, true)
  crId: number | undefined = undefined;
  @JsonProperty('crStop', Number, true)
  crStop: number | undefined = undefined;
  @JsonProperty('crT', Number, true)
  crTtIndex: number | undefined = 0;
  @JsonProperty('crD', String, true)
  crDelayQuery: string | undefined = undefined;
  @JsonProperty('crE', String, true)
  exceptionDescription: string | undefined = undefined;

  iconClass(): string {
    if (this.vehicleType == 'V')
      return 'K';
    else if (this.lineType === 'A')
      return 'M';

    return 'S';
  }
}
